// Centralized view count management
export const getViewCounts = (): Record<string, number> => {
  if (typeof window === 'undefined') return {}
  const stored = localStorage.getItem('helpArticleViews')
  return stored ? JSON.parse(stored) : {}
}

export const incrementViewCount = (articleId: string): number => {
  const viewCounts = getViewCounts()
  const currentCount = viewCounts[articleId] || 0
  const newCount = currentCount + 1
  viewCounts[articleId] = newCount
  localStorage.setItem('helpArticleViews', JSON.stringify(viewCounts))
  return newCount
}

export const getTotalViews = (
  articleId: string,
  baseViews: number = 0,
): number => {
  const viewCounts = getViewCounts()
  return baseViews + (viewCounts[articleId] || 0)
}
